import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

function RequestFormWidgetCheckbox(props) {
  const { disabled, label, onChange, options, value } = props;
  
  const isChecked = value === options.checked;

  const handleToggle = () => {
    if (disabled) return;
    const newValue = isChecked ? options.unchecked : options.checked;
    onChange(newValue);
  };

  return (
    <div className="flex items-center gap-4 mb-3 py-1">
      <div className="w-1/4">
        <label className="text-[14px] font-normal text-[#212529] font-['Open_Sans'] cursor-pointer select-none" onClick={handleToggle}>
          {options?.labelId ? (
            <FormattedMessage id={options.labelId} defaultMessage={options?.label} />
          ) : options?.label ? (
            <span>{options.label}</span>
          ) : (
            <FormattedMessage id={options?.checked || label} />
          )}
        </label>
      </div>
      <div className="flex items-center justify-start">
        <button
          type="button"
          disabled={disabled}
          onClick={handleToggle}
          className={`w-5 h-5 rounded border-2 transition-all flex items-center justify-center ${
            isChecked 
              ? 'bg-[#5882C1] border-[#5882C1] text-white' 
              : 'bg-white border-gray-400 hover:border-[#5882C1]'
          } ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
          data-cy={String(label).toLowerCase()}
        >
          {isChecked && (
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="4" className="w-3 h-3">
              <polyline points="20 6 9 17 4 12" />
            </svg>
          )}
        </button>
      </div>
    </div>
  );
}

RequestFormWidgetCheckbox.propTypes = {
  disabled: PropTypes.bool,
  label: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.shape({
    checked: PropTypes.any,
    unchecked: PropTypes.any,
  }).isRequired,
  value: PropTypes.any,
};

RequestFormWidgetCheckbox.defaultProps = {
  disabled: false,
  label: '',
  value: undefined,
};

export default RequestFormWidgetCheckbox;
